import React from 'react';
import classes from './HeaderLayout.module.scss';
import { isMobile } from 'react-device-detect';
import { useLocation, useNavigate } from 'react-router-dom';
import { RightArrowIcon } from '../../../assets/icons/modifiedIcons';
import useQuery from '../../../hooks/useQuery';

const MaterialTestHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isCertificatePath = location.pathname.includes(
    '/materialtest/certificate'
  );

  // Check if we're on a detail or edit page by looking for an ID in the URL
  const isDetailOrEdit = /\/materialtest\/certificate\/(\d+)(\/edit)?$/.test(
    location.pathname
  );

  // Extract ID from the URL for detail or edit pages
  const certificateId = isDetailOrEdit
    ? location.pathname.match(/\/materialtest\/certificate\/(\d+)/)?.[1]
    : null;

  const handleNavigate = path => {
    navigate(path);
  };

  return (
    <div>
      <div className={classes.breadCrumbContainer}>
        {isCertificatePath ? (
          <>
            <span
              className={classes.breadcrumbStyle}
              onClick={() => handleNavigate('/materialtest')}
            >
              Material Test
            </span>
            <span>
              <RightArrowIcon fontSize={16} />
            </span>
            <span
              className={
                isDetailOrEdit
                  ? classes.breadcrumbStyle
                  : classes.heatDetailsHeaderText
              }
              style={{ fontSize: isMobile ? '12px' : '16px' }}
              onClick={
                isDetailOrEdit
                  ? () => handleNavigate('/materialtest/certificate')
                  : undefined
              }
            >
              Certificate
            </span>

            {isDetailOrEdit && certificateId && (
              <>
                <span>
                  <RightArrowIcon fontSize={16} />
                </span>
                <span
                  className={classes.heatDetailsHeaderText}
                  style={{ fontSize: isMobile ? '12px' : '16px' }}
                >
                  {`Report #${certificateId}`}
                </span>
              </>
            )}
          </>
        ) : (
          <span
            className={classes.heatDetailsHeaderText}
            style={{ fontSize: isMobile ? '12px' : '16px' }}
          >
            Material Test
          </span>
        )}
      </div>
    </div>
  );
};

export default MaterialTestHeader;
